import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import images from '../images/images';
import {gaCountryNotFound} from '../gaReports';

const EmptySearchResultComponent = (props) => {
  useEffect(() => {
    if (props.searchValue?.length > 1) {
      gaCountryNotFound(
        props.activeLobbyTab,
        props.startedFromPackage,
        props.searchValue,
        props.isSeparatedSale,
        props.isBusinessIndividual
      );
    }
  }, []);

  const title = `לא מצאנו את היעד שחיפשתם  <br/> <span class="bold">שננסה שוב?</span>`;
  return (
    <Container className='empty-search-result'>
      <Row>
        <Col className='text-center'>
          <Image src={images.point} alt='icon' />
        </Col>
      </Row>
      <Row>
        <Col className='text-center'>
          <span className='newPurple' dangerouslySetInnerHTML={{__html: title}} />
        </Col>
      </Row>
    </Container>
  );
};

export default EmptySearchResultComponent;
